import fant from '@/libs/fant-plugins'
import mixinApp from "./mixin.js";
import extend from './extend';
import preview from 'vue-photo-preview3'
import 'vue-photo-preview3/dist/skin.css'
//基于各个浏览器和系统的不同，重写了中文字的拼音排序比较
import "./pinyin-sort.js";
/* 组件全局注册 */
import fantImg from "@/components/fantImg.vue";
// import { importInstall } from './importPlugin'
// export * from './importPlugin'

function Plugins(){
}
Plugins.install = (app, router, store)=>{
    /* 初始化公司内部插件 */
    app.use(fant,{store})
    /* 混入方法变量 */
    mixinApp(app);
    //扩展或重新集合
    app.use(extend);
    /* 初始化图片预览组件 */
    app.use(preview);

    /* 全局组件注册 */
    app.component("fantImg", fantImg);

    // importInstall(app)
    
    
    /* app.config.globalProperties.$fileUplaod = function(param) {
        let urlUplaod = this.$FILE_URL + "/web/firm/file";
        let numSize = 10;
        if (param.data && param.data.size) {
            numSize = param.data.size;
        }
        if (param.data && param.data.url) {
            urlUplaod = param.data.url;
        }
        if (param.file.size > 1024 * 1024 * numSize) {
            this.$message({
                msg: "上传文件大小不能超出" + numSize + "MB",
                type: "error",
            });
            return;
        }
        var fdata = new FormData();
        fdata.append("file", param.file);
        this.$http.post(urlUplaod, fdata, {
            headers: { "Content-Type": "multipart/form-data" },
        }).then((res) => {
            if (res.ok) {
                res.param = param.data;
                param.onSuccess(res);
            } else {
                param.onError(res);
            }
        });
    }; */
}

export default Plugins